import { Size } from '@/types';
import { getParams } from '@/utils/params';
import { postToDesignerService } from './fetchFromDesignerService';

export const createBendingTextDesign = (svgContent: string) =>
  postToDesignerService<{ designId: string; size: Size }>(
    `${getParams().context}s/${getParams().contextId}/text/upload`,
    svgContent,
    undefined,
    { headers: { 'Content-Type': 'image/svg+xml' } }
  );
